
import getSymbolFromCurrency from "currency-symbol-map";

export const AcFormatCurrencyAmount = (amount = 0, currency = 'EUR', language = 'en', withSymbol = true) => {
  let currencySymbol = getSymbolFromCurrency(currency);

  if (!currencySymbol) {
    currencySymbol = '€';
  }

  const int = new Intl.NumberFormat(language, {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  let result = int.format(amount / 100);

  if (withSymbol) {
    return `${currencySymbol} ${result}`;
  } else {
    return result;
  }
};

export default AcFormatCurrencyAmount;
